import { Component, OnInit, OnDestroy } from '@angular/core';
import { SearchService } from '../../search/search.service';
import { AlertService } from 'sce-core';
import { SearchableEntityServiceFactory } from '../../services/searchable-entity/searchable-entity-service-factory';
import { SimpleEntityDataService } from '../../services/searchable-entity/simple-entity/simple-entity-data.service';
import { SimpleEntityActionService } from '../../services/searchable-entity/simple-entity/simple-entity-action.service';
import { SimpleEntityDataEditorService } from '../../services/searchable-entity/simple-entity/simple-entity-data-editor.service';
import { SimpleEntityBackendService } from '../../services/searchable-entity/simple-entity/simple-entity-backend.service';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_ROW_EVENT, PAGE_OVERFLOW_EVENT } from '../../../shared/search/search-constants';
import { SearchCriteria } from '../../search/models/search-filter-model';
import { ConfirmDialogService } from 'sce-core';
import { ModalService } from './../../services/modal.service';
import { DataTableConfig } from '../../search/models/data-table-config';


@Component({
  selector: 'lfwms-import-lookup-popup',
  templateUrl: './import-lookup-popup.component.html',
  styleUrls: ['./import-lookup-popup.component.css'],
  providers: [SimpleEntityDataService,
    SimpleEntityActionService,
    SimpleEntityBackendService,
    SimpleEntityDataEditorService],
})
export class ImportLookupComponent implements OnInit, OnDestroy {

  public ImportsearchService: SearchService;
  public lookupAlertService: AlertService;
  public confirmDialogService: ConfirmDialogService;
  public title: string;
  public config = { animated: false };
  public subscription: any;
  public displayMode: string;


  public serviceFactory: SearchableEntityServiceFactory;
  protected resourceService: any;
  public dataService: any;
  protected actionService: any;
  protected dataEditor: any;
  protected buttonService: any;
  protected backendService: any;
  public eventSubscription: any;
  public tableId: string = '';

  constructor(public modalService: ModalService) {
    this.lookupAlertService = new AlertService();
    this.confirmDialogService = new ConfirmDialogService();
  }

  public ngOnInit() {
    this.displayMode = 'V';
  }

  // initialising service from search factorty from parent component(Import Component)
  public initializeServices(serviceFactory: SearchableEntityServiceFactory) {
    if (!serviceFactory) {
      return;
    }

    this.actionService = serviceFactory.getActionService();
    this.backendService = serviceFactory.getBackendService();
    this.dataEditor = serviceFactory.getDataEditor();
    this.buttonService = serviceFactory.getButtonService();
    this.dataService = serviceFactory.getDataService();

    // set the alert service instance of the popup
    this.dataService.alertService = this.lookupAlertService;
    this.buttonService.alertService = this.lookupAlertService;
    this.actionService.alertService = this.lookupAlertService;
    this.backendService.alertService = this.lookupAlertService;

    this.dataService.searchService = this.dataService.getSearchService();
    this.dataService.searchParams = this.dataService.getSearchService().searchParams;
    this.tableId = this.dataService.searchParams.tableId;
    if (this.tableId === 'STORETOLOCIMPORTTD') {
      const tableConfig: DataTableConfig = this.dataService.getSearchService().searchParams.dataTableConfig;
      tableConfig.isColumnEditable = this.isColumnEditable;
      this.dataService.searchParams.dataTableConfig = tableConfig;
    }

    this.dataService.searchStatus = this.dataService.getSearchService().searchStatus;
    if (this.buttonService) {
      this.dataService.searchParams.actionButtons = this.buttonService.getButtonsForPanel('search-table');
    }
    if (!this.dataService.searchService.getSearchCriteria()) {
      const defaultSearchCriteria = new SearchCriteria();
      this.dataService.searchService.setSearchCriteria(defaultSearchCriteria);
    }    
    //LFWM-3437 - for stock take omport table display mode is set to E, so we can save the data to DB
    this.tableId === 'STKTAKIMPTD' ? this.dataService.setDisplayMode('E') : this.dataService.setDisplayMode('V');    
    this.buttonService.initializeSearchPageButtons();
    this.eventSubscription = this.dataService.searchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        if (event.type === NEW_ROW_EVENT) {
          this.dataService.handleAddNewRow(event.selectedRow);
        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the current page and navigate to the next
          // page on success
          this.dataService.searchService.setNewPageEventInProgress(true);
          this.buttonService.performButtonActions('Save');
        }
      });
    this.dataService.searchService.performSearch();
  }

  // method to handle poppup buttons
  public handleButtonPanelActions(action: any) {
    this.buttonService.performButtonActions(action);
  }


  /**
  * If the table is in View Mode make all columns as non editable
  * In the Edit Mode, make columns editable based on its metadata
  * In Create Mode, make all columns as editable
  * @paramdisplayType : The column displayType as in metadata
  */
  private isColumnEditable(params: any) {
    // this component is used for other screens like cyclecount so to avoid conflict this is done
    if (params.context.componentParent.searchParams.tableId === 'STORETOLOCIMPORTTD') {
      const rowData = params.data;
      const componentRef = params.context.componentParent;
      // if the table is in view mode, do not make any column as editable
      if (['V', 'P'].indexOf(componentRef.tableMode) !== -1) {
        return false;
      }

      const isNewRow: boolean = rowData && rowData['isNewItem'] && rowData['isNewItem'].cVal;
      if (isNewRow) {
        return true;
      } else {
        // enable the column only if it is an editable field in the metadata
        return (['E', 'L', 'EA', 'EL'].indexOf(componentRef.metaDataMap[params.colDef.colId].displayType) > -1);
      }
    }

  }

  public ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/import-lookup/import-lookup-popup.component.ts